class MeetTheTeam extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('.meet-the-team__trigger').forEach((trigger) => {
      trigger.addEventListener('click', (event) => this.handleTriggerClick(event));
    });

    const openItem = this.querySelector('.meet-the-team__item[data-open]');
    if (openItem) {
      this.updateLifestyleImage(openItem.dataset.member);
    }
  }

  handleTriggerClick(event) {
    const trigger = event.currentTarget;
    const item = trigger.closest('.meet-the-team__item');
    const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

    this.querySelectorAll('.meet-the-team__item').forEach((el) => {
      el.removeAttribute('data-open');
      const elTrigger = el.querySelector('.meet-the-team__trigger');
      if (elTrigger) {
        elTrigger.setAttribute('aria-expanded', 'false');
      }
    });

    if (!isExpanded) {
      item.setAttribute('data-open', '');
      trigger.setAttribute('aria-expanded', 'true');
      this.updateLifestyleImage(item.dataset.member);
    }
  }

  updateLifestyleImage(memberId) {
    this.querySelectorAll('.meet-the-team__lifestyle-slide').forEach((slide) => {
      slide.classList.toggle(
        'meet-the-team__lifestyle-slide--active',
        slide.dataset.member === memberId
      );
    });
  }
}

customElements.define('meet-the-team', MeetTheTeam);
